import {useState, useEffect, useCallback, useRef} from 'react';

import {producaov2} from '../../../../services/apis';
import { useRouter } from '../../../../hooks/router';

export default function useProjects() {
  const initialFilterApplied = useRef(false);

  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const router = useRouter();

  const handleChangePage = (page) => {
    setPage(page);
  }

  const getProjects = useCallback(async ({silentLoading = false, initialFilters = {}} = {}) => {
    if(!silentLoading) {
      setIsLoading(true);
    } else {
      setIsRefreshing(true);
    }

    const finalFilters = !initialFilterApplied.current ? initialFilters : filters;

    try {
      const response = await producaov2.get('/admin/projetosV2', {
        params: {
          page: page + 1,
          limit: rowsPerPage,
          ...(finalFilters?.user && {user: finalFilters?.user}),
          ...(finalFilters?.ordering && {ordering: finalFilters?.ordering || 'desc'}),
          ...(finalFilters?.courseID !== "all" && {courseID: finalFilters?.courseID}),
          ...(finalFilters?.approval !== "all" && {approval: finalFilters?.approval}),
          ...(finalFilters?.status !== "all" && {status: finalFilters?.status})
        }
      });

      setProjects(response.data);

      if(!initialFilterApplied.current) {
        onChangeFilters(initialFilters);
        initialFilterApplied.current = true;
      }
    } catch(error) {

    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  }, [filters, page, initialFilterApplied, rowsPerPage]);

  const refreshProjects = () => {
    getProjects()
  }

  useEffect(() => {
    getProjects({
      initialFilters: {
        ...(router?.query?.id_aluno && {user: router?.query?.id_aluno})
      }
    });
  }, [page, filters, getProjects, router, rowsPerPage]);

  const onChangeFilters = (filters) => {
    setFilters(filters);
    setPage(0);
  }

  const onChangeRowsPerPage = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage);
  }

  return {
    projects,
    page,
    isLoading,
    isRefreshing,
    filters,
    rowsPerPage,
    onChangePage: handleChangePage,
    onChangeFilters,
    onChangeRowsPerPage,
    refreshProjects
  }
}